import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState: {
  modalOpen: boolean;
} = {
  modalOpen: false,
};

const countryChangeModalSlice = createSlice({
  name: "countryChangeModal",
  initialState,
  reducers: {
    reset: () => {
      return initialState;
    },
    updateCountryChangeModal: (
      state,
      action: PayloadAction<typeof initialState>
    ) => {
      // eslint-disable-next-line no-param-reassign
      state = action.payload;
      return state;
    },
  },
});

export const { reset, updateCountryChangeModal } =
  countryChangeModalSlice.actions;
export default countryChangeModalSlice.reducer;
